var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('a',{class:_vm.titleClassName,attrs:{"href":_vm.href,"title":_vm.title || ''},on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }